<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="info"
        block
        v-on="on"
      >
        Copy EPF
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Employees' Provident Fund replication"
      text="Copy EPF from a past year"
      class="mb-0"
    > 
      <form
        v-if="dialog"
        ref="detailCreateForm"
      >
        <v-container class="pb-0">
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="form.baseYear"
                v-validate="'required'"
                prepend-icon="event"
                :error-messages="errors.collect('baseYear')"
                data-vv-name="baseYear" 
                data-vv-as="base year"
                :items="availableYears"
                item-text="name"
                return-object
                label="Base Year"
              />
            </v-col>
          </v-row> 

          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="form.destinationYear"
                v-validate="'required'"
                prepend-icon="event"
                :error-messages="errors.collect('destinationYear')"
                data-vv-name="destinationYear"
                data-vv-as="destination year"  
                :items="validYears"
                item-text="name"
                return-object
                label="Destination Year"
              />
            </v-col>
          </v-row>
        </v-container>       
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Copy
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {      
      availableYears: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        form: {
          baseYear: null,
          destinationYear: null,
        },
      }
    },
    computed: {
      validYears () {
        return [
          this.$moment().year(),
          this.$moment().year() + 1,
        ]
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) {
          this.$resetData()
        }
      },
    },
  
    methods: { 
      prepareFormData () {
        return {
          ...this.form,
        }
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 
            this.setProgressing(true)
    
            this.$api.epf().createMany(this.prepareFormData())
              .then((res) => {
                if (res.status === 200) {
                  this.$snack({ message: 'EPF successfully copied' })
                  this.$validator.pause()

                  this.setDialog(false)
                  this.$emit('created', this.form.destinationYear)                
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
    },
  }
</script>

<style lang="css" scoped>
  ::v-deep .datepicker .v-btn{
      padding:0 !important;
      border-radius: 50%;
  }

</style>
